import { motion } from "framer-motion";

export const Rocket = ({ className = "" }) => (
  <svg viewBox="0 0 220 260" fill="none" className={className} aria-hidden="true">
    {/* flame */}
    <path
      d="M96 196 C90 224 78 240 66 252 C84 248 94 240 100 230 C102 244 108 254 116 258 C116 244 118 234 124 226 C130 236 142 242 156 244 C146 232 138 216 132 196 Z"
      fill="#F59E0B"
    />
    <path
      d="M102 200 C100 218 94 230 88 238 C98 234 104 228 108 220 C110 230 114 238 120 242 C120 230 122 222 126 216 C130 224 136 230 144 232 C138 222 132 210 128 200 Z"
      fill="#FBBF24"
    />
    {/* fins */}
    <path d="M64 150 C48 166 40 186 40 206 L72 190 C70 176 68 162 64 150 Z" fill="#1E40AF" />
    <path d="M156 150 C172 166 180 186 180 206 L148 190 C150 176 152 162 156 150 Z" fill="#1E40AF" />
    {/* body */}
    <path
      d="M110 8 C142 34 156 84 156 132 C156 162 148 186 132 202 L88 202 C72 186 64 162 64 132 C64 84 78 34 110 8 Z"
      fill="#3B82F6"
    />
    <path
      d="M110 8 C142 34 156 84 156 132 C156 140 155.5 148 154 156 C128 168 92 168 66 156 C64.5 148 64 140 64 132 C64 84 78 34 110 8 Z"
      fill="#60A5FA"
      opacity="0.55"
    />
    {/* window */}
    <circle cx="110" cy="96" r="34" fill="#FFFFFF" stroke="#1E40AF" strokeWidth="7" />
    <circle cx="110" cy="100" r="17" fill="#FCD9B8" />
    <path d="M93 96 C93 84 100 78 110 78 C120 78 127 84 127 96 C119 90 101 90 93 96 Z" fill="#7C4A21" />
    <circle cx="104" cy="99" r="2.2" fill="#1E293B" />
    <circle cx="116" cy="99" r="2.2" fill="#1E293B" />
    <path d="M104 107 C107 110 113 110 116 107" stroke="#1E293B" strokeWidth="2" strokeLinecap="round" />
    {/* rivets */}
    <circle cx="88" cy="180" r="4" fill="#1E40AF" />
    <circle cx="110" cy="186" r="4" fill="#1E40AF" />
    <circle cx="132" cy="180" r="4" fill="#1E40AF" />
  </svg>
);

export const FloatingRocket = ({ className = "" }) => (
  <motion.div
    className={className}
    animate={{ y: [0, -16, 0], rotate: [0, 2, 0, -2, 0] }}
    transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
  >
    <Rocket className="w-full h-full drop-shadow-xl" />
  </motion.div>
);
